// extracted by mini-css-extract-plugin
var _1 = "PostViewBannerEditor-module__animateUploadProgressBarWidth--dHDzM";
var _2 = "PostViewBannerEditor-module__animatedBackground--fTWtq";
var _3 = "PostViewBannerEditor-module__banner--gPSz_";
var _4 = "PostViewBannerEditor-module__bannerButton--nT4UK";
var _5 = "PostViewBannerEditor-module__bannerContainer--rEujk";
var _6 = "PostViewBannerEditor-module__bannerControls--LFz9Y";
var _7 = "PostViewBannerEditor-module__bannerControlsContainer--K1qP_";
var _8 = "380px";
var _9 = "672px";
var _a = "PostViewBannerEditor-module__dragZoomInfoPillContainer--IkcDR";
var _b = "PostViewBannerEditor-module__isEditing--RPX1g";
var _c = "PostViewBannerEditor-module__isPositioning--jUmMo";
var _d = "PostViewBannerEditor-module__savePositionButton--kOhvH";
var _e = "PostViewBannerEditor-module__shouldShowControls--UROax";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "banner", _4 as "bannerButton", _5 as "bannerContainer", _6 as "bannerControls", _7 as "bannerControlsContainer", _8 as "bannerHeight", _9 as "bannerWidth", _a as "dragZoomInfoPillContainer", _b as "isEditing", _c as "isPositioning", _d as "savePositionButton", _e as "shouldShowControls" }
